import { css } from 'styled-components'

export const BLOCK_SELECT = css`
  -webkit-user-select: none;
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
`
export const ALLOW_SELECT = css`
  -webkit-user-select: text;
  -ms-user-select: text; /* IE 10 and IE 11 */
  user-select: text; /* Standard syntax */
`
